import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import switchDoctor from '../api/switchDoctor';
import { INIT } from '../routes/paths';
import { dispatch } from '../bridge/events/dispatch';
import { Menu } from 'antd';
import { flushPatientFuseInstance } from './allPatientsIndex';
import { AccountResponse } from '../api/fetchDocAccounts';
import { Myprofiles } from '../api/fetchMyProfiles';
import { getMyProfileList } from '../store/localstorage';

const ChangePersona: React.FC<{
    accountList?: AccountResponse['data'];
    className?: string;
    title?: string;
    closeDropDown?: () => void;
}> = ({ accountList, className, title, closeDropDown }) => {
    const [profiles, setProfiles] = useState<Myprofiles['data']['users']>(
        accountList as Myprofiles['data']['users'],
    );
    const [fetchState, setFetchState] = useState<'loading' | 'success' | 'error' | 'switch'>(
        'loading',
    );

    const history = useHistory();

    useEffect(() => {
        setProfiles(getMyProfileList());
    }, []);

    if (!profiles || profiles.length === 0) {
        return null;
    }

    const onProfileSelect = (oid: string) => {
        closeDropDown && closeDropDown();
        setFetchState('switch');
        switchDoctor(oid, true)
            .then(() => {
                flushPatientFuseInstance();
                dispatch({
                    type: 'DR_SWITCH_EVENT',
                });
                history.replace(INIT);
            })
            .catch(console.error);
        // changeDoc(docId);
        // history.push(GO_TO_STAFF_SETUP_APP);
    };

    // if (fetchState === 'loading') {
    //     return (
    //         <Menu
    //             style={{
    //                 boxShadow:
    //                     '0 3px 6px -4px rgba(0,0,0,.12), 0 6px 16px 0 rgba(0,0,0,.08), 0 9px 28px 8px rgba(0,0,0,.05)',
    //             }}
    //             className="flex w-272 flex-col rounded-8 p-0 profile-dropdown-overlay h-200"
    //         >
    //             <Menu.Item
    //                 className="flex flex-col items-center justify-center"
    //                 style={{ height: '100%', width: '100%' }}
    //             >
    //                 <div className="pulse">
    //                     <svg width="16px" height="12px">
    //                         <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
    //                         <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
    //                     </svg>
    //                 </div>
    //             </Menu.Item>
    //         </Menu>
    //     );
    // }

    return (
        <Menu
            style={{
                boxShadow:
                    '0 3px 6px -4px rgba(0,0,0,.12), 0 6px 16px 0 rgba(0,0,0,.08), 0 9px 28px 8px rgba(0,0,0,.05)',
            }}
            className={
                className ??
                'flex w-272 switch-profile-menu flex-col max-h-360 rounded-8 p-0 profile-dropdown-overlay flex flex-col rounded-8 p-0 profile-dropdown-overlay'
            }
        >
            <div className="font-lato select-none border-b border-darwin-neutral-100 flex gap-8 items-center py-8 px-16 text-13 font-700">
                <svg
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.2656 7.41211L13.2969 9.44336C13.5254 9.69727 13.5254 10.0781 13.2969 10.3066L11.2656 12.3379C11.1641 12.4648 11.0117 12.5156 10.8594 12.5156C10.6816 12.5156 10.5293 12.4648 10.4277 12.3379C10.1738 12.1094 10.1738 11.7285 10.4277 11.5L11.418 10.4844H8.625C8.42188 10.4844 8.24414 10.4082 8.14258 10.2559L6.69531 8.32617L7.43164 7.31055L8.92969 9.26562H11.418L10.4023 8.27539C10.1484 8.04688 10.1484 7.66602 10.4023 7.4375C10.6309 7.18359 11.0117 7.18359 11.2656 7.41211ZM1.10938 3.98438C0.753906 3.98438 0.5 3.73047 0.5 3.375C0.5 3.04492 0.753906 2.76562 1.10938 2.76562H3.75C3.92773 2.76562 4.10547 2.86719 4.23242 3.01953L5.6543 4.94922L4.91797 5.96484L3.44531 3.98438H1.10938ZM11.418 3.98438H8.92969L4.23242 10.2559C4.10547 10.4082 3.92773 10.4844 3.75 10.4844H1.10938C0.753906 10.4844 0.5 10.2305 0.5 9.875C0.5 9.54492 0.753906 9.26562 1.10938 9.26562H3.44531L8.11719 3.01953C8.24414 2.86719 8.42188 2.76562 8.625 2.76562H11.418L10.4277 1.77539C10.1738 1.54688 10.1738 1.16602 10.4277 0.9375C10.6562 0.683594 11.0371 0.683594 11.2656 0.9375L13.2969 2.96875C13.5254 3.19727 13.5254 3.57812 13.2969 3.83203L11.2656 5.83789C11.1641 5.96484 11.0117 6.01562 10.8594 6.01562C10.6816 6.01562 10.5293 5.96484 10.4277 5.83789C10.1738 5.60938 10.1738 5.22852 10.4277 5L11.418 3.98438Z"
                        fill="#484848"
                    />
                </svg>
                {title ?? 'Switch profiles'}
            </div>
            <div className="overflow-scroll hide-scrollbar">
                {profiles?.map((d, index) => (
                    <Menu.Item
                        className={`flex-shrink-0 px-24`}
                        style={{ height: '100%', margin: 0, paddingTop: 4, paddingBottom: 8 }}
                    >
                        <div
                            key={'profile' + index}
                            onClick={() => onProfileSelect(d.profile.oid)}
                            className="py-8 flex flex-row space-x-12 items-center "
                        >
                            <div className="overflow-hidden flex-shrink-0 h-36 w-36 rounded-8 rounded-12">
                                <img
                                    src={
                                        d.business?.logo ??
                                        'https://a.eka.care/user-avatar/dummyimage'
                                    }
                                    alt={d.profile.fln}
                                />
                            </div>
                            <div className="flex w-80p flex-col flex-1 space-y-4">
                                <div className="font-700 overflow-hidden overflow-ellipsis whitespace-nowrap text-neutral-black text-13 capitalize">
                                    {d.business?.name}
                                </div>
                                <div className="text-neutral-4 overflow-hidden overflow-ellipsis whitespace-nowrap text-11">
                                    {d.profile.fln}
                                </div>
                            </div>
                        </div>
                    </Menu.Item>
                ))}
            </div>
        </Menu>
    );
};

export default ChangePersona;
